module.exports = __webpack_public_path__ + "img/how-much.f835362d.png";